module.exports = __webpack_public_path__ + "static/media/live19_05_2023.7448770d.jpeg";